import React from "react";
import { Row, Col, Placeholder } from "react-bootstrap";
import MainCard from "../../Components/Cards/MainCard";

const EmailTemplateSkeleton = () => {
  return (
    <>
      {/* --- Form Layout --- */}
      <Row>
        {/* --- Left: App Logo --- */}
        <Col xs={12} sm={3}>
          <div className="border rounded p-3 h-100 d-flex flex-column align-items-center justify-content-center">
            <Placeholder
              animation="wave"
              className="rounded-circle bg-secondary mb-2"
              style={{ width: "100px", height: "100px" }}
            />
            <Placeholder.Button xs={6} variant="secondary" />
          </div>
        </Col>

        {/* --- Right: Notification Email Template --- */}
        <Col xs={12} sm={9}>
          <div className="border rounded p-3">
            <Placeholder as="div" animation="wave" className="w-100">
              <Placeholder xs={12} />
              <Placeholder xs={12} />
              <Placeholder xs={10} />
              <Placeholder xs={8} />
            </Placeholder>
            <div className="mt-3">
              <Placeholder as="div" animation="wave" className="w-100">
                <Placeholder xs={12} />
                <Placeholder xs={9} />
              </Placeholder>
            </div>
          </div>
        </Col>
      </Row>

      {/* --- Color Theme Selector --- */}
      <div className="d-flex gap-3 w-100 mt-3  flex-wrap">
        {[...Array(4)].map((_, i) => (
          <Placeholder
            key={i}
            animation="wave"
            className="rounded bg-secondary"
            style={{
              width: "25%",
              height: "40px",
              display: "block",
            }}
          />
        ))}
      </div>

      <br />

      {/* --- Save Button --- */}
      <Placeholder.Button variant="secondary" xs={2} />
    </>
  );
};

export default EmailTemplateSkeleton;
